import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const FilterTypeSelector = ({ onChange, value, filterTypes = [], sections, disabled }) => {
  const { t } = useTranslation()

  const menuItems = filterTypes.map(type => ({
    label: t(type.label),
    value: type.value,
    section: type.section,
  }))

  const renderedSections = sections
    ? sections
        .filter(section => filterTypes.some(ft => ft.section === section.id))
        .map(section => ({
          label: t(section.label),
          id: section.id,
          Icon: section.Icon,
        }))
    : undefined

  return (
    <div>
      <ComboBox
        fullWidth
        menuItems={menuItems}
        label={t('Filtrar por')}
        value={value}
        handleChange={e => onChange(e.target.value)}
        disabled={disabled}
        sections={renderedSections}
      />
    </div>
  )
}

export default FilterTypeSelector
